var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-bg"},[_c('img',{staticClass:"empty-img",attrs:{"src":require("../../../static/images/empty.png"),"width":"352","height":"262","alt":""}}),_c('div',{staticClass:"empty-text"},[_vm._v("您所访问的系统已暂停服务...")])])
}]

export { render, staticRenderFns }